import { render, staticRenderFns } from "./payroll.vue?vue&type=template&id=475c464a&scoped=true&"
import script from "./payroll.vue?vue&type=script&lang=js&"
export * from "./payroll.vue?vue&type=script&lang=js&"
import style0 from "./payroll.vue?vue&type=style&index=0&id=475c464a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475c464a",
  null
  
)

export default component.exports